import { render } from "./BulkSms.vue?vue&type=template&id=747f4458"
import script from "./BulkSms.vue?vue&type=script&lang=js"
export * from "./BulkSms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__